export default defineNuxtPlugin(async () => {
  await ensureShopDomainResolved()
})
